import { getDecodedJwt } from '@bb-remark/web-utils';

export const fetchUserPreferences = async (jwt) => {
  const { user_id, tenant_id } = getDecodedJwt();
  const result = await fetchData(`/api/v1/pdfviewer/tenants/${tenant_id}/users/${user_id}/preferences`, jwt);
  return result.preferences ?? {};
};

export const setUserPreferences = async (preferences, jwt) => {
  const { user_id, tenant_id } = getDecodedJwt();
  await putData(`/api/v1/pdfviewer/tenants/${tenant_id}/users/${user_id}/preferences`, preferences, jwt);
};

export const fetchUserStamps = async (jwt) => {
  const { user_id, tenant_id } = getDecodedJwt();
  const result = await fetchData(`/api/v1/pdfviewer/tenants/${tenant_id}/users/${user_id}/stamps`, jwt);
  return result.stamps ?? {};
};

export const saveUserStamps = async (stamps, jwt) => {
  const { user_id, tenant_id } = getDecodedJwt();
  await putData(`/api/v1/pdfviewer/tenants/${tenant_id}/users/${user_id}/stamps`, stamps, jwt);
};

const fetchData = async (url, jwt) => {
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${jwt}`
    },
  });

  if (response.status !== 200) {
    console.error('err', response);
    return {};
  }

  const result = await response.json();
  return result;
};

const putData = async (url, body, jwt) => {
  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${jwt}`,
      'Content-Type': 'application/json',
    },
    body,
  });

  if (response.status !== 200) {
    console.error('err', response);
  }
};

export const stampAnnotationToJson = (stampAnnotation) => {
  const bbox = stampAnnotation.boundingBox;
  const color = stampAnnotation.color ? { r: stampAnnotation.color.r, g: stampAnnotation.color.g, b: stampAnnotation.color.b } : {};
  return {
    stampType: stampAnnotation.stampType,
    title: stampAnnotation.title,
    subtitle: stampAnnotation.subtitle,
    color,
    bbox: { left: bbox.left, top: bbox.top, width: bbox.width, height: bbox.height },
    createdAt: stampAnnotation.createdAt.toISOString(),
  };
};

export const textToObject = (object) => {
  if (object.color) {
    return new PSPDFKit.Color(object.color);
  }
  if (object.cloudy_border_inset) {
    return new PSPDFKit.Geometry.Inset(object.cloudy_border_inset);
  }
  if (object.bounding_box) {
    return new PSPDFKit.Geometry.Rect(object.bounding_box);
  }
  return object;
};

export const getNonDefaultPresets = (preferences, preset, newPresetProperties) => {
  const updatedKeys = Object.keys(preferences[preset] ?? {}).filter(key => ((PSPDFKit.defaultAnnotationPresets[preset][key] !== preferences[preset][key]) &&
    (preferences[preset][key] !== null)));
  preferences[preset] = updatedKeys.reduce((result, key) => ({ ...result, [key]: preferences[preset][key] }), {});

  Object.keys(preferences[preset] ?? {}).forEach(key => {
    if (preferences[preset][key] instanceof Object && !(preferences[preset][key] instanceof Array)) {
      let newKey;
      let attributes = [];
      if (preferences[preset][key] instanceof PSPDFKit.Color) {
        newKey = 'color';
        attributes = ['r', 'g', 'b'];
      }
      else if (preferences[preset][key] instanceof PSPDFKit.Geometry.Inset) {
        newKey = 'cloudy_border_inset';
        attributes = ['bottom', 'left', 'right', 'top'];
      }
      else if (preferences[preset][key] instanceof PSPDFKit.Geometry.Rect) {
        newKey = 'bounding_box';
        attributes = ['left', 'top', 'width', 'height'];
      }
      if (newKey) {
        let objPreference = {};
        attributes.forEach((attribute) => {
          objPreference[attribute] = (newPresetProperties[key] ?? preferences[preset][key])[attribute];
        });
        preferences[preset][key] = { [newKey]: objPreference };
      }
    }
  });

  if (Object.keys(preferences[preset] ?? {}).length === 0) {
    delete preferences[preset];
  }
  return preferences;
};

export const getStringFromObject = (key, object) => {
  return JSON.stringify({ [key]: object });
};